export const SET_COOKIE = "@EE/SET_COOKIE";
export const EXPIRE_COOKIE = "@EE/EXPIRE_COOKIE";

export const ADD_PAYMENT = "@EE/ADD_PAYMENT";
export const REMOVE_PAYMENT = "@EE/REMOVE_PAYMENT";
export const SET_PAYMENT_METHOD = "@EE/SET_PAYMENT_METHOD";
export const CLEAR_PAYMENT_METHOD = "@EE/CLEAR_PAYMENT_METHOD";

export const SAVE_DELIVERY_METHOD = "@EE/SAVE_DELIVERY_METHOD";

export const COMMIT = "@EE/COMMIT";
export const ERROR = "@EE/ERROR";
export const CLEAR_ERROR = "@EE/CLEAR_ERROR";

export const CALL_API = "@EE/CALL_API";

export const CONFIG_LOADED = "@EE/CONFIG_LOADED";
export const LANGUAGE_LOADED = "@EE/LANGUAGE_LOADED";

export const SET_PAYMENT_OPTION = "@EE/SET_PAYMENT_OPTION";
export const CLEAR_PAYMENT_OPTION = "@EE/CLEAR_PAYMENT_OPTION";
